const EDITOR_PATHNAME = "/editor"

export const isStoryblokPreview = (): boolean => {
  if (typeof window === "undefined") {
    return false
  }

  const search = window.location?.search ?? ""

  return (
    search.includes("_storyblok_tk") ||
    search.includes("_storyblok=") ||
    window.location?.pathname?.startsWith(EDITOR_PATHNAME) === true
  )
}
